import 'angular-translate';
import 'messageformat';
import 'angular-translate-interpolation-messageformat';
import countriesEN from './countriesEN';
import localizationMapEN from './mapEN';
import localizationMapDE from './mapDE';

localizationMapEN.countryCodes = countriesEN;

export default angular.module('app.config.localization', [
  'pascalprecht.translate'
])
  .service('countryCodesOptions', function($filter){
    return Object.keys(countriesEN).map(countryCode => {
      return {value: countryCode, name: $filter('translate')('countryCodes.'+countryCode)};
    })
  })
  .config(function($translateProvider) {
    $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
    $translateProvider.useSanitizeValueStrategy(null);
    $translateProvider.preferredLanguage('en');

    $translateProvider.translations('en', localizationMapEN);
    $translateProvider.translations('de', localizationMapDE);
  });



/** WEBPACK FOOTER **
 ** ./src/configs/localization/localization.js
 **/